
let formatAsHelpers = {

    price: function(val) {
        if (!val.length) {
            return '';
        }

        val = val.replace(/[^\d\,]/g, '').replace(/\,/,'.');

        let formatter = new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: 'TRY',
          
            // These options are needed to round to whole numbers if that's what you want.
            //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
            //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
        });
          
        return formatter.format(val).replace(/[^\d\.\,]/g, '');
    },

    unit: function(val) {
        val = val.replace(/[^\d\-]/g, '');
        return Math.max(0, (parseInt(val) || 0));
    },

    decimal: function(val) {
        val = val.replace(/\,/g,'.')
                    .replace(/[^\d\.]/g, '')
                    .replace(/(^\.*|\.*$)/g, '')
                    .replace(/(.*)\./, x => x.replace(/\./g,'')+'.');
        return parseFloat(val) || '';
    },

    rate: function(val) {
        return Math.max(0, Math.min(100, parseFloat(val.replace(/[^\d\.]/g, '')))) || 0;
    }

}

Array.from(document.querySelectorAll('input[data-format-as]')).forEach(function(input) {

    input.addEventListener('blur', function() {

        let formatter = input.getAttribute('data-format-as');
        input.value = formatAsHelpers[formatter](input.value.trim());

    })

})

let inputFormatHelper = {

    price: function(val) {
        if (!val.length) {
            return '';
        }
          
        return val.replace(/[^\d\,]/g, '');
    },

    rate: function(val) {
        return val.replace(/[^\d\.]/g, '');
    }

}

Array.from(document.querySelectorAll('input[data-input-format]')).forEach(function(input) {

    input.addEventListener('input', function() {

        let formatter = input.getAttribute('data-input-format');
        input.value = inputFormatHelper[formatter](input.value.trim());

    })

})


function setInputFilter(textbox, inputFilter) {
    ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
      textbox.addEventListener(event, function() {
        if (inputFilter(this.value)) {
          this.oldValue = this.value;
          this.oldSelectionStart = this.selectionStart;
          this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty("oldValue")) {
          this.value = this.oldValue;
          this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        } else {
          this.value = "";
        }
      });
    });
  }

let inputAllowHelper = {

    prefixedphone: function(val) {
        return (/^[\d\s\(\)\-]*$/).test(val);
    },

    phone: function(val) {
        return (/^[\d\s\(\)\-\+]*$/).test(val);
    },

    digit: function(val) {
        return (/^\d*$/).test(val);
    },

    decimal: function(val) {
        return (/^\d*(\.|\,)?\d*$/).test(val);
    },

    rate: function(val) {
        return (/^\d*\.?\d*$/).test(val);
    }

}

Array.from(document.querySelectorAll('input[data-input-allow]')).forEach(function(input) {

    let formatter = input.getAttribute('data-input-allow');
    setInputFilter(input, inputAllowHelper[formatter])

})